module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_16.cb354a84.png";